// extracted by mini-css-extract-plugin
export default {"pageWrap":"Pf-z","fullWidth":"Qf-z","heading":"Rf-z","fullBleed":"Sf-z","hidden":"Tf-z"};